import { DashboardBlockCustomTableColumnDefaultFilter, DashboardPageBlockCustomTableGraphSerieType, RequestStatus, defaults } from 'typed/api';
import { combineReducers, entityLoadAllReducer, switchReducers, synchronizableEnumReducer } from './utils';
import { ActionType } from 'utils/constants';
import { deepAssign } from 'typed/utils';

const dlgs = defaults.NetworkArrayOf(defaults.DashboardGroupLightReport);

export default combineReducers({
    dashboardLightGroups: switchReducers(dlgs,
        entityLoadAllReducer(dlgs, 'LOAD_ALL_LIGHT_DASHBOARD_GROUPS'),
        (state, action) => {
            const nextState = state || dlgs;

            switch (action.type) {
                case ActionType.ADD_DASHBOARD_GROUP_SUCCESS:
                case ActionType.EDIT_DASHBOARD_GROUP_SUCCESS:
                case ActionType.DELETE_DASHBOARD_GROUP_SUCCESS:
                case ActionType.ADD_DASHBOARD_PAGE_SUCCESS:
                case ActionType.ADD_DASHBOARD_PAGE_FROM_TEMPLATE_SUCCESS:
                case ActionType.CLONE_DASHBOARD_PAGE_SUCCESS:
                case ActionType.CLONE_DASHBOARD_PAGE_WITH_FILTERS_SUCCESS:
                case ActionType.EDIT_DASHBOARD_PAGE_SUCCESS:
                case ActionType.DELETE_DASHBOARD_PAGE_SUCCESS:
                case ActionType.ADD_ALL_DASHBOARD_PAGE_USER_ACCESSES_SUCCESS:
                case ActionType.DELETE_ALL_DASHBOARD_PAGE_USER_ACCESSES_SUCCESS:
                case ActionType.VOID_ALL_DASHBOARD_PAGES:
                case ActionType.ADD_DASHBOARD_BLOCK_SUCCESS:
                case ActionType.ADD_DASHBOARD_BLOCK_FROM_TEMPLATE_SUCCESS:
                case ActionType.CLONE_DASHBOARD_BLOCK_SUCCESS:
                case ActionType.EDIT_DASHBOARD_BLOCK_SUCCESS:
                case ActionType.MOVE_DASHBOARD_BLOCK_TO_ANOTHER_PAGE_SUCCESS:
                case ActionType.DELETE_DASHBOARD_BLOCK_SUCCESS:
                    return deepAssign(nextState, { Custom: { status: RequestStatus.UNSYNCED } });

                default:
                    return nextState;
            }
        }
    ),
    dashboardPageTemplates: entityLoadAllReducer(defaults.NetworkArrayOf(defaults.DashboardPageTemplate), 'LOAD_ALL_DASHBOARD_PAGE_TEMPLATES'),
    dashboardPageBlockTemplates: entityLoadAllReducer(defaults.NetworkArrayOf(defaults.DashboardPageBlockTemplate), 'LOAD_ALL_DASHBOARD_PAGE_BLOCK_TEMPLATES'),
    dashboardBlockCustomTableGraphSerieTypes: synchronizableEnumReducer(
        defaults.NetworkArrayOf(defaults.DashboardPageBlockCustomTableGraphSerieType),
        'LOAD_ALL_DASHBOARD_BLOCK_CUSTOM_TABLE_GRAPH_SERIE_TYPE',
        DashboardPageBlockCustomTableGraphSerieType as any,
        'DashboardPageBlockCustomTableGraphSerieType'
    ),
    dashboardBlockCustomTableColumnDefaultFilters: synchronizableEnumReducer(
        defaults.NetworkArrayOf(defaults.DashboardPageBlockCustomTableColumnDefaultFilter),
        'LOAD_ALL_DASHBOARD_BLOCK_CUSTOM_TABLE_COLUMN_DEFAULT_FILTERS',
        DashboardBlockCustomTableColumnDefaultFilter as any,
        'DashboardPageBlockCustomTableColumnDefaultFilter'
    )
});
